export default __webpack_public_path__ + "static/media/user-icon.80cfbffa.svg";